import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-undetermined-progress-bar',
  templateUrl: './undetermined-progress-bar.component.html',
  styleUrl: './undetermined-progress-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class UndeterminedProgressBarComponent {
  /** Height of the bar (e.g. '4px', '8px') */
  @Input() height = '4px';
}
